import React from 'react';
import { Headphones, TrendingUp, Globe } from 'lucide-react';

const Services = () => {
  const services = [
    {
      id: 1,
      icon: Headphones,
      title: 'On-call GIS Support',
      description: 'Expert support when you need it',
      color: 'text-[#6A7EC9]',
      bg: 'bg-[#6A7EC9]/10'
    },
    {
      id: 2,
      icon: TrendingUp,
      title: 'Business & GIS Analysis',
      description: 'Data-driven insights and management',
      color: 'text-[#33C7A9]',
      bg: 'bg-[#33C7A9]/10'
    },
    {
      id: 3,
      icon: Globe,
      title: 'Interactive Maps & Dashboards',
      description: 'Custom web-based mapping solutions',
      color: 'text-[#6A7EC9]',
      bg: 'bg-[#6A7EC9]/10'
    }
  ];

  return (
    <section className="py-12 bg-white border-b border-gray-200">
      <div className="container mx-auto px-6">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            How We Can Help Your Team
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {services.map((service) => {
            const IconComponent = service.icon;
            return (
              <div
                key={service.id}
                className="flex flex-col items-center text-center p-6 rounded-lg hover:bg-gray-50 transition-colors duration-300"
              >
                <div className={`inline-flex p-3 rounded-xl ${service.bg} mb-3`}>
                  <IconComponent className={`h-6 w-6 ${service.color}`} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {service.title}
                </h3>
                <p className="text-sm text-gray-600">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
